export default __webpack_public_path__ + "static/media/card2.61737506.png";